
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as indexhGCaLCzdWsiUdwPW0A7DDZAhy8MLrE9laDi8jElTD7QMeta } from "/opt/buildhome/repo/pages/cart/index.vue?macro=true";
import { default as indexyKJndJfcGDAsz7Ce4dWIudcxoKLK8VQ_lr_45vb2qPJEMMeta } from "/opt/buildhome/repo/pages/terms/index.vue?macro=true";
import { default as indexrMM2pb1xNKpc9dn0El6FwInZ7F8HIHFEh6lVMb_KLsUMeta } from "/opt/buildhome/repo/pages/orders/index.vue?macro=true";
import { default as indexF6gMVyupBslJ_452_453uCVtE4o10pKHSfl8qwDlotQKGKEMeta } from "/opt/buildhome/repo/pages/product/index.vue?macro=true";
import { default as index7QKLwLCIT_45THbx_45ct5mcXhlazlKay3S7hSKRkZDWmbIMeta } from "/opt/buildhome/repo/pages/proposals/index.vue?macro=true";
import { default as indexp3B47BuDD0jV28NpWuvMjDOoswuUWvpBWGiRb5VmuFYMeta } from "/opt/buildhome/repo/pages/closed-kits/index.vue?macro=true";
import { default as indexqV8psAi0o5pyalRn0kme1yhu4I3ryacINxl_45Cts2eNoMeta } from "/opt/buildhome/repo/pages/custom-kits/index.vue?macro=true";
import { default as indexmRiCT0MBCsyHBdziaY2DDposLgtjMh6ZykgL_45bgvyTEMeta } from "/opt/buildhome/repo/pages/spare-products/index.vue?macro=true";
import { default as indexIo8dFhu1vtiYkZZdCKnRDlxcPLdO2iK69k1LXH8gpaAMeta } from "/opt/buildhome/repo/pages/checkout/confirm/index.vue?macro=true";
import { default as indexxXDTztmi2sxDN4P59Scvm_Hwxp6UieqQsvFCYs84HZgMeta } from "/opt/buildhome/repo/pages/checkout/payment/index.vue?macro=true";
import { default as indexrwqM7p3OuU3Ztj3GCs6JqQ5LFsGdjXittiNCCHqX9ioMeta } from "/opt/buildhome/repo/pages/orders/[orderId]/index.vue?macro=true";
import { default as indexSSYF9DJfD3tTmIJ84E3DTNxSILPU8ipHhjEO1gEuJm4Meta } from "/opt/buildhome/repo/pages/checkout/shipping/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/pages/cart/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexyKJndJfcGDAsz7Ce4dWIudcxoKLK8VQ_lr_45vb2qPJEMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/terms/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/opt/buildhome/repo/pages/orders/index.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/opt/buildhome/repo/pages/product/index.vue")
  },
  {
    name: "proposals",
    path: "/proposals",
    component: () => import("/opt/buildhome/repo/pages/proposals/index.vue")
  },
  {
    name: "closed-kits",
    path: "/closed-kits",
    meta: { ...(indexp3B47BuDD0jV28NpWuvMjDOoswuUWvpBWGiRb5VmuFYMeta || {}), ...{"middleware":["home"]} },
    component: () => import("/opt/buildhome/repo/pages/closed-kits/index.vue")
  },
  {
    name: "custom-kits",
    path: "/custom-kits",
    component: () => import("/opt/buildhome/repo/pages/custom-kits/index.vue")
  },
  {
    name: "spare-products",
    path: "/spare-products",
    component: () => import("/opt/buildhome/repo/pages/spare-products/index.vue")
  },
  {
    name: "checkout-confirm",
    path: "/checkout/confirm",
    meta: indexIo8dFhu1vtiYkZZdCKnRDlxcPLdO2iK69k1LXH8gpaAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/confirm/index.vue")
  },
  {
    name: "checkout-payment",
    path: "/checkout/payment",
    meta: indexxXDTztmi2sxDN4P59Scvm_Hwxp6UieqQsvFCYs84HZgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/payment/index.vue")
  },
  {
    name: "orders-orderId",
    path: "/orders/:orderId()",
    component: () => import("/opt/buildhome/repo/pages/orders/[orderId]/index.vue")
  },
  {
    name: "checkout-shipping",
    path: "/checkout/shipping",
    meta: indexSSYF9DJfD3tTmIJ84E3DTNxSILPU8ipHhjEO1gEuJm4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/shipping/index.vue")
  }
]